// extracted by mini-css-extract-plugin
export var container = "_5a-0";
export var disabled = "_5a-4";
export var fullWidth = "_5a-3";
export var lined = "_5a-1";
export var selected = "_5a-5";
export var tab = "_5a-2";